import React from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon } from 'lucide-react';
import type { Slot } from '../../types/slot';
import { useSiteSettings } from '../../contexts/SiteSettingsContext';
import { formatRtp, getProviderSlug } from '../../utils/slots';
import { SlotThumb } from '../SlotThumb';
import { ScoreBadge } from '../ScoreBadge';
import { RealMoneyButton } from '../RealMoneyButton';
export const rowGrid = 'md:grid-cols-[44px_minmax(0,1fr)_84px_96px_92px_64px_212px]';
export function SlotRow({
  slot,
  onDemo
}: {
  slot: Slot;
  onDemo: (s: Slot) => void;
}) {
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  const isTop3 = slot.rank <= 3;
  return <li className={`grid grid-cols-[32px_minmax(0,1fr)_auto] items-center gap-x-4 gap-y-3 border-b border-line px-4 py-4 last:border-b-0 sm:px-6 ${rowGrid}`} data-id="element-236" data-mp="152vy1ccntvrv">
      <span className={`font-serif font-semibold tabular-nums ${isTop3 ? 'text-2xl text-oranje' : 'text-xl text-muted'}`} data-id="element-237" data-mp="196ae230lmc5b">
        {slot.rank}
      </span>

      <div className="flex min-w-0 items-center gap-3.5" data-id="element-238" data-mp="1xcjq1jwdnhyn">
        <SlotThumb slot={slot} size="sm" data-id="element-239" data-mp="1taexyplkute4" />
        <div className="min-w-0" data-id="element-240" data-mp="1t9dnoncdyaxg">
          <Link to={`/slots/${slot.slug}`} className="block truncate font-semibold text-ink underline-offset-2 hover:underline" data-id="element-241" data-mp="1tcjc00d6x8s4">
            {slot.name}
          </Link>
          <Link to={`/providers/${getProviderSlug(slot.provider)}`} className="block truncate text-sm text-muted hover:text-ink" data-id="element-242" data-mp="1jeby5qe776uc">
            {slot.provider}
          </Link>
          <p className="mt-0.5 truncate text-xs text-muted md:hidden" data-id="element-243" data-mp="279y2z9j3dom7">
            RTP {formatRtp(slot.rtp)} · {slot.volatility} · {slot.maxWin}
          </p>
        </div>
      </div>

      <span className="hidden text-sm tabular-nums md:block" data-id="element-244" data-mp="2290ob6xajcpg">{formatRtp(slot.rtp)}</span>
      <span className="hidden text-sm md:block" data-id="element-245" data-mp="2zsbtsp60gabs">{slot.volatility}</span>
      <span className="hidden text-sm tabular-nums md:block" data-id="element-246" data-mp="2uyqvsx4f3gcl">{slot.maxWin}</span>

      <div className="justify-self-end md:justify-self-start" data-id="element-247" data-mp="t1qgaecsjfwu">
        <ScoreBadge score={slot.score} data-id="element-248" data-mp="x3kac3shdlo1" />
      </div>

      <div className="col-span-3 flex gap-2 md:col-span-1 md:justify-end" data-id="element-249" data-mp="x2ad1gtgchig">
        <button type="button" onClick={() => onDemo(slot)} className="inline-flex h-9 flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border border-line bg-surface px-3.5 text-sm font-semibold text-ink transition-colors duration-150 hover:border-ink/30 md:flex-none" aria-label={`Speel ${slot.name} gratis demo`} data-id="element-250" data-mp="jcyoq7bn6xmg">
          <PlayIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-251" data-mp="dui157kpfxy" />
          Demo
        </button>
        {showRealMoneyCtas ? <RealMoneyButton slot={slot} size="sm" className="flex-1 md:flex-none" data-id="element-252" data-mp="5cxngqrgto6g" /> : <Link to={`/slots/${slot.slug}`} className="inline-flex h-9 flex-1 items-center justify-center whitespace-nowrap rounded-lg bg-fern px-3.5 text-sm font-semibold text-white hover:bg-fern-dark md:flex-none" data-id="element-253" data-mp="1urvg3nvatywz">
            Review
          </Link>}
      </div>
    </li>;
}